import React from 'react';
import * as R from 'ramda';
import { Link } from 'react-router-dom';
import { useUserRolePermissions } from 'hooks';
import { Box, Button, Typography } from '@mui/material';
import SmallModuleButton from 'common/SmallModuleButton';
import SwiftLogo from 'assets/img/dashboard-swift-logo.svg';
import MagellanLogo from 'assets/img/dashboard-magellan-logo.svg';
import ChangeCircleRoundedIcon from '@mui/icons-material/ChangeCircleRounded';
import AltRouteRoundedIcon from '@mui/icons-material/AltRouteRounded';
import DataUsageRoundedIcon from '@mui/icons-material/DataUsageRounded';
import { RELEASE_NOTES_URL } from 'utils/constants';
import { hasAnyRoles, userRoles } from 'utils/currentUserRoles';
import packageJson from '../../../package.json';

const Dashboard = () => {
  const { currentAffiliate } = useUserRolePermissions();

  const buttons = [
    {
      disabled: R.not(hasAnyRoles([userRoles.PRODUCT_OWNERSHIP_VIEW, userRoles.INVENTORY_OWNER])),
      icon: <DataUsageRoundedIcon fontSize="inherit" />,
      label: 'Inventory Dashboard',
      loading: R.isNil(currentAffiliate),
      to: '../inventory-dashboard',
    },
    {
      disabled: R.not(hasAnyRoles([userRoles.PRODUCT_OWNERSHIP_VIEW, userRoles.INVENTORY_OWNER])),
      icon: <ChangeCircleRoundedIcon fontSize="inherit" />,
      label: 'Product Transfer Orders',
      loading: R.isNil(currentAffiliate),
      to: '../product-ownership/open',
    },
    {
      disabled: R.not(hasAnyRoles([userRoles.PRODUCT_OWNERSHIP_VIEW, userRoles.INVENTORY_OWNER])),
      icon: <AltRouteRoundedIcon fontSize="inherit" />,
      label: 'Reconsignments',
      loading: R.isNil(currentAffiliate),
      to: '../reconsignments',
    },
  ];

  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        height: { sm: '100vh', xs: 'initial' },
        justifyContent: 'space-between',
        pb: 6,
        pt: 7,
        px: 2,
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flex: '0.5',
          justifyContent: 'center',
          mx: 0,
          my: 2,
        }}
      >
        <Link to="../..">
          <img alt="Swift" src={SwiftLogo} />
        </Link>
      </Box>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
        {buttons.map(({ label, ...rest }) => (
          <SmallModuleButton key={label} label={label} {...rest} />
        ))}
      </Box>
      <Box
        sx={{
          alignItems: 'flex-end',
          display: 'flex',
          flex: '1',
          justifyContent: 'center',
          mx: 0,
          my: 2,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <Button
            href={RELEASE_NOTES_URL}
            sx={{
              mb: 'auto',
              mt: 2,
              mx: 'auto',
              padding: '2px 0',
              width: 56,
            }}
            target="_blank"
            variant="text"
          >
            Release Notes
          </Button>
          <img
            alt="Magellan Midstream Partners, L.P."
            src={MagellanLogo}
            style={{ marginBottom: '24px' }}
          />
          <Typography align="center" sx={{ mb: 3 }} variant="caption">
            Version {packageJson.version}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Dashboard;
